import React from 'react';
import find from 'lodash/find';

import propTypes from 'prop-types';
import PriceSpan from 'common/components/formatters/PriceSpan';
import QuantityInput from 'common/components/QuantityInput';
import { TranslatedMessage } from 'common/components/Intl';
import Close from '!svg-react-loader?!images-react-svg/icons_v2/close.svg';
import {
  getPodCount,
  getNicotinePercent,
  getNicotineMilligrams,
} from 'common/utils/lineItem';

export default class LineItem extends React.Component {
  static propTypes = {
    item: propTypes.object.isRequired,
    quantityProcessing: propTypes.number,
    handleQuantityChange: propTypes.func.isRequired,
    variants: propTypes.array.isRequired,
    discountPerItem: propTypes.number.isRequired,
  };

  handleQuantityChange = quantity => {
    this.props.handleQuantityChange({ quantity, lineItem: this.props.item });
  };

  handleItemRemoval = () => {
    this.handleQuantityChange(0);
  };

  render() {
    const { item, variants, discountPerItem, quantityProcessing } = this.props;
    const quantity = Number.isInteger(quantityProcessing)
      ? quantityProcessing
      : item.quantity;

    const variant = variants.find(v => v.sku === item.sku);
    const originalPrice = parseFloat(item.price) * item.quantity;
    const totalPrice = originalPrice - discountPerItem;

    const offerIsInactive = !!find(variant.variant_offerings.inactive, {
      id: item.variant_offering_id,
    });

    const quantityInput = offerIsInactive ? (
      <p className="cart__line-item__unavailable text--body--small">
        <TranslatedMessage id="cart.item_unavailable" />
      </p>
    ) : (
      <QuantityInput
        compact={true}
        value={quantity}
        onChange={this.handleQuantityChange}
      />
    );

    const podCount = getPodCount(item);

    // Pod strength
    let strength = getNicotineMilligrams(item);
    if (!strength) {
      const nicotinePercent = getNicotinePercent(item);
      if (nicotinePercent) {
        // Adding % if nicotine_strength_percent option as it does not have a unit
        strength = `${nicotinePercent}%`;
      }
    }

    return (
      <div className="cart__line-item">
        <a className="cart__line-item__image-link" href={variant.url}>
          <img className="cart__line-item__image" src={`${item.image}?w=200`} />
        </a>

        <button
          className="cart__line-item__remove"
          onClick={this.handleItemRemoval}
        >
          <Close />
        </button>

        <h4 className="cart__line-item__name heading--small">
          <a className="cart__line-item__name__link" href={variant.url}>
            {variant.name}
          </a>
        </h4>

        <div className="cart__line-item__meta subheading--small">
          {strength && podCount ? (
            <>
              <TranslatedMessage
                id={'cart.nicotine_strength'}
                values={{ strength }}
              />
              <br />
              <TranslatedMessage
                id={'cart.pod_count'}
                values={{ pod_count: podCount }}
              />
              {' - '}
              <TranslatedMessage
                id={'cart.price_each'}
                values={{
                  price: <PriceSpan amount={parseFloat(item.price)} />,
                }}
              />
            </>
          ) : (
            item.options_text
          )}
        </div>

        <div className="cart__line-item__quantity">{quantityInput}</div>

        <div className="cart__line-item__prices">
          {discountPerItem > 0 && (
            <PriceSpan
              className="cart__line-item__price--original subheading--small"
              amount={originalPrice}
            />
          )}
          <PriceSpan
            className="cart__line-item__price heading--small"
            amount={totalPrice}
          />
        </div>
      </div>
    );
  }
}
